import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import CollapsibleDetailView from "@components/molecules/CollapsibleDetailView";
import { VDBIcons } from "@utils/VDBIcons";
import { useState } from "react";
import styled from "styled-components/native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";
import RenderHTML from "react-native-render-html";
import { css } from "styled-components/native";
import { Icon } from "@utils/customization";
import { DefaultTheme } from "styled-components/native";

type ShippingInformationProps = {
  title: string;
  description: string;
  descriptionHeight: number;
  icon: Icon;
};

const ShippingInformation = ({
  title,
  description,
  descriptionHeight,
  icon,
}: ShippingInformationProps) => {
  const [expandView, setExpandView] = useState(false);
  const { theme, typography, t } = useScreenOptionsHooks();

  const headerView = () => {
    return (
      <>
        <HeaderView>
          {icon?.type === "font" ? (
            <VDBIcon
              color={
                icon?.color
                  ? (theme[icon?.color as keyof DefaultTheme] as string)
                  : theme["core-06"]
              }
              size={24}
              variant={IconsVariant.VDBCustom}
              name={icon?.data}
            />
          ) : icon?.type === "url" ? (
            <VDBIcon
              name={undefined}
              variant={IconsVariant.CustomUrl}
              uri={icon?.data}
              size={24}
              color={
                icon?.color
                  ? (theme[icon?.color as keyof DefaultTheme] as string)
                  : theme["core-06"]
              }
            />
          ) : (
            <VDBIcon
              color={
                icon?.color
                  ? (theme[icon?.color as keyof DefaultTheme] as string)
                  : theme["core-06"]
              }
              size={24}
              variant={IconsVariant.VDBCustom}
              name={VDBIcons.INFO_COMMENT}
            />
          )}
          <VDBText color={theme["core-05"]} type={typography["H3-M"]}>
            {t(title)}
          </VDBText>
        </HeaderView>
        <Spacer size={SpaceType.Double} />
        <DescriptionView expanded={expandView} height={descriptionHeight}>
          <RenderHTML
            source={{ html: t(description) }}
            tagsStyles={{
              body: typography["Minor-R"],
              b: {
                ...typography["Minor-M"],
              },
            }}
          />
        </DescriptionView>
      </>
    );
  };

  return (
    <CollapsibleDetailView
      setExpandView={setExpandView}
      expanded={expandView}
      title={headerView()}
      arrowStyling={{ color: theme["core-04"] }}
    />
  );
};

const HeaderView = styled.View`
  flex-direction: row;
  gap: ${SpaceType.Basic}px;
  align-items: center;
`;

const DescriptionView = styled.View<{
  expanded: boolean;
  height: number;
}>`
  ${({ expanded, height }) =>
    !expanded &&
    css`
      height: ${height > 0 ? height : 76}px;
    `}
  overflow: hidden;
`;

export default ShippingInformation;
